/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { camelCase, camelCaseTransformMerge } from 'camel-case';

export const isNull = (pValue: any): boolean => {
  let isNullAux = false;
  if (pValue === undefined || pValue === null) {
    isNullAux = true;
  }
  return isNullAux;
};

export const isValue = (pValue: any) => {
  let isValue2 = false;
  if (pValue !== undefined && pValue != null) {
    isValue2 = true;
  }
  return isValue2;
};
// //   statusCodesToRetry: [[100, 199], [429, 429], [500, 599]],

export const isRangeNumber = (number: number, rangesNumber: any) => {
  let isInRange = false;

  for (const [min, max] of rangesNumber) {
    if (number >= min && number <= max) {
      isInRange = true;
      break;
    }
  }
  return isInRange;
};

export const setEntityName = (URL: string) => {
  const entityName = camelCase(URL, {
    transform: camelCaseTransformMerge,
  });

  return `${entityName}Response`;
};
